<template>
  <nav id="main-nav" class="navbar navbar-expand-sm navbar-light">
    <div class="container" style="max-height: 100%;">
      <div class="d-inline-flex align-items-center ham-menu">
        <button class="navbar-toggler p-0 " type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation" style="height: 35px; width: 35px;">
          <span class="bi bi-list bi-2x text-light"></span>
        </button>
      </div>
      <a href="/" class="navbar-brand m-0 d-flex align-items-center not-login-stay-left">
        <img id="main-logo" src="/static/img/logo/logo-social789.png" />
      </a>

      <div id="auth-wrapper" class="group-button-user p-1 rounded-pill login-b mobile">
        <div class="d-inline-flex">
          <a @click="gotoRouteMobile('/register')"
            class="nav-link register-btn btn btn-custom-secondary rounded-pill d-flex align-items-center pt-1 pb-1 text-white justify-content-center"
            aria-label="register" v-if="$route.name !== 'Register'">
            <span class="fw-bold text-highlight d-flex align-items-center"><i
                class="bi bi-person-plus-fill me-1 text-white"></i>
              สมัครสมาชิก</span>
          </a>
          <a @click="gotoRouteMobile('/login')"
            class="nav-link login-btn btn btn-custom-primary rounded-pill gradient d-flex align-items-center pt-1 pb-1 ms-2 justify-content-center"
            aria-label="login" v-if="$route.name !== 'Login'">
            <span class="fw-bold text-highlight d-flex align-items-center"><i class="bi bi-box-arrow-in-right me-1"></i>
              เข้าสู่ระบบ</span>
          </a>
        </div>
      </div>
      <div id="auth-wrapper" class="group-button-user p-1 rounded-pill login-b desktop">
        <div class="d-inline-flex">
          <router-link to="/register"
            class="nav-link register-btn btn btn-custom-secondary rounded-pill d-flex align-items-center pt-1 pb-1 text-white justify-content-center"
            aria-label="register" v-if="$route.name !== 'Register'">
            <span class="fw-bold text-highlight d-flex align-items-center"><i
                class="bi bi-person-plus-fill me-1 text-white"></i>
              สมัครสมาชิก</span>
          </router-link>
          <router-link to="/login"
            class="nav-link login-btn btn btn-custom-primary rounded-pill gradient d-flex align-items-center pt-1 pb-1 ms-2 justify-content-center"
            aria-label="login" v-if="$route.name !== 'Login'">
            <span class="fw-bold text-highlight d-flex align-items-center"><i class="bi bi-box-arrow-in-right me-1"></i>
              เข้าสู่ระบบ</span>
          </router-link>
        </div>
      </div>
      <div class="collapse navbar-collapse navbar-content-index" id="navbarSupportedContent">
        <div class="navbar-nav ms-auto align-items-center">
          <li class="nav-item header-group-menu pt-3">
            <span>Pages</span>
          </li>
          <li class="nav-item bg-box-1 nc-home btn-home ">
            <a href="/" class="nav-link btn btn-box-1 d-flex align-items-center btn-lg active position-relative">
              <span class="text-highlight">หน้าหลัก</span>
            </a>
          </li>
          <li class="nav-item bg-box-1  btn-article ">
            <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`"
              class="nav-link btn btn-box-1 d-flex align-items-center btn-lg  position-relative" target="_blank">
              <span class="text-highlight">ติดต่อเรา</span>
            </a>
          </li>

          <li class="nav-item header-group-menu pt-3">
            <span>Games</span>
          </li>
          <li class="nav-item cutom-game-entry d-flex justify-content-center btn-slot invert-color position-relative "
            data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <a @click="gotoRouteGame('/')" tag="a" class="nav-link btn btn-box-1 d-flex align-items-center btn-lg">
              <span class="nav-item-text text-highlight">
                สล๊อต
              </span>
            </a>
          </li>
          <li class="nav-item cutom-game-entry d-flex justify-content-center btn-baccarat invert-color position-relative "
            data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <a @click="gotoRouteGame('/')" tag="a" class="nav-link btn btn-box-1 d-flex align-items-center btn-lg">
              <span class="nav-item-text text-highlight">
                บาคาร่า
              </span>
            </a>
          </li>
          <li class="nav-item cutom-game-entry d-flex justify-content-center btn-poker invert-color position-relative "
            data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <a @click="gotoRouteGame('/')" tag="a" class="nav-link btn btn-box-1 d-flex align-items-center btn-lg">
              <span class="nav-item-text text-highlight">
                โป้กเกอร์
              </span>
            </a>
          </li>
          <li class="nav-item cutom-game-entry d-flex justify-content-center btn-trade invert-color position-relative "
            data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <a @click="gotoRouteGame('/')" tag="a" class="nav-link btn btn-box-1 d-flex align-items-center btn-lg">
              <span class="nav-item-text text-highlight">
                เทรด
              </span>
            </a>
          </li>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",
  data() {
    return {
      isShowNav: true,
      toggle: true,

      nowPage: this.$route.name,
    };
  },
  watch: {
    $route() {
      this.isShowNav = true;
      this.nowPage = this.$route.name;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "appTitle"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => { });
    },
    gotoRouteMobile(route) {

      var myCollapse = document.getElementById('navbarSupportedContent')
      console.log(myCollapse.classList.contains('show'))
      if (myCollapse.classList.contains('show')) {
        var bsCollapse = new bootstrap.Collapse(myCollapse)
        bsCollapse.hide()
      }
      this.$router.push(route).catch(() => { });
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => { });
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
  },
  computed: {
    ...mapGetters(["getLineId"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue